module.exports = __webpack_public_path__ + "img/img_ch1_open.64b8d556.jpg";